import {Injectable} from "@angular/core";
import {ConfProxy, HttpObservable} from "../../../common/http/services";

@Injectable({ providedIn: 'root' })
  export class FlagsProxy {
	constructor(private confHttp: ConfProxy) {
	}

	public getFlagsActionCode(): HttpObservable<{ [code: number]: string }> {
		return this.confHttp.get("FlagsManager", "GetFlagsActionCode");
	}
}
